// Implements: .fs-btn from ui_kits/rehaut-flagships/flagship.css — ONE
// button dialect (FLAGSHIPS Bet 2). Variants: primary/ghost/quiet/danger.
'use client';

import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'ghost' | 'quiet' | 'danger';

export function Button({
  variant = 'ghost',
  size,
  className,
  children,
  type = 'button',
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: 'lg';
  children: ReactNode;
}) {
  const cls = ['fs-btn', variant, size, className].filter(Boolean).join(' ');
  return (
    <button type={type} className={cls} {...rest}>
      {children}
    </button>
  );
}
